import { fetchStrapiSingleType } from './strapiClient';

export async function fetchMentionsLegalesFromStrapi() {
  return fetchStrapiSingleType('mentions-legales');
}
